<template>
    <v-container fluid>
        <!-- inicio de cambiar de rancho -->
        <v-row class="pa-0 ma-0 align-center"
               justify="center"
               no-gutters>
            <v-col cols="8" justify="justify-center" class="ma-0 pa-0">
                <ChangeRanch
                    :paddock="paddockSelected"
                    :paddocks="currentPaddocks">
                </ChangeRanch>
            </v-col>
        </v-row>
        <!-- fin de cambiar de rancho -->

        <!-- inicio de texto principal -->
        <v-row class="my-3 px-2 smart-title-2 home-title-container-mobile"
               no-gutters>
            <v-col cols="12" class="d-flex align-center justify-center">
                <div class="unselectable" style="text-align:center">Separa tu ganado en potreros. Crea tu primer potrero.</div>
            </v-col>
        </v-row>
        <!-- fin de texto principal -->

        <!-- inicio de paneles expansivos-->

        <!-- inicio de Datos Generales-->
        <v-expansion-panels multiple accordion class="my-6">
            <v-expansion-panel>
                <v-expansion-panel-header class="expansion-panel-background-color">
                    <b class="smart-title-2 home-title-container-mobile">Datos Generales</b>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="expansion-panel-background-color">
                    <v-col cols="12" class="d-flex flex-wrap pa-0">

                        <!-- inicio de selector de Tipo de Potrero-->
                        <div class="col-12 std-text-sm std-text-blue-2 pa-0 mt-1">Tipo de Potrero</div>
                        <v-row no-gutters class="form-input-animal-container std-text-md my-3"
                               align-content="space-between"
                               justify="center">
                            <!-- inicio de selector Preconfigurado -->
                            <v-col cols="" class="mr-1 align-end">
                                <div class="ml-0 d-flex align-center justify-center full-height form-button-disabled px-0 std-border-radius std-text-sm-open"
                                     :class="[{'form-animal-active' : animalType === 'cow'}, {'elevation-3' : animalType === 'cow'}]"
                                     height="50%"
                                     width="">Preconfigurado
                                </div>
                            </v-col>
                            <!-- fin de selector Preconfigurado -->

                            <!-- inicio de selector Personalizado -->
                            <v-col cols="" class="ml-1">
                                <div class="mr-0 d-flex align-center justify-center full-height form-button-disabled px-0 std-border-radius std-text-sm-open"
                                     :class="[{'form-animal-active' : animalType === 'cow'}, {'elevation-3' : animalType === 'cow'}]"
                                     height="40px"
                                     width="50%">Personalizado
                                </div>
                            </v-col>
                            <!-- fin de selector Personalizado -->
                        </v-row>
                        <!-- fin de selector de Tipo de Potrero-->

                        <!--inicio de Nombre Potrero -->
                        <div class="col-12 std-text-sm std-text-blue-2 pa-0 mt-1">Nombre del Potrero</div>
                        <v-autocomplete
                                class="mb-2"
                                hide-details
                                dense
                                flat
                                placeholder="General"
                                outlined
                                required
                        ></v-autocomplete>
                        <!--Fin de Nombre Potrero -->

                        <!--inicio de input Descripcion -->
                        <div class="col-12 std-text-sm std-text-blue-2 pa-0 mt-1">Descripción</div>
                        <v-text-field
                                v-mask="'####-####'"
                                placeholder="¡Aquí están todas las vacas en tu rancho!"
                                dense
                                outlined
                                hide-details
                                height= "60px"
                        ></v-text-field>
                        <!-- fin de input Descripcion -->
                    </v-col>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <!-- fin de Datos Generales-->

        <!-- inicio de Seleccion de Vacas-->
        <v-expansion-panels multiple accordion class="my-6">
            <v-expansion-panel>
                <v-expansion-panel-header class="expansion-panel-background-color">
                    <b class="smart-title-2">Método Selección Vacas</b>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="expansion-panel-background-color">
                    <v-col cols="12" class="d-flex flex-wrap pa-0">
                        <!-- inicio de selector de Seleccion de Vacas-->
                        <div class="col-12 std-text-sm std-text-blue-2 pa-0 mt-1">Selección de vacas</div>
                        <v-row no-gutters class="form-input-animal-container std-text-md my-3"
                               align-content="space-between"
                               justify="center">
                            <!-- inicio de selector Automatico -->
                            <v-col cols="" class="mr-1 align-end">
                                <div class="ml-0 d-flex align-center justify-center full-height form-button-disabled px-0 std-border-radius std-text-sm-open"
                                     :class="[{'form-animal-active' : animalType === 'cow'}, {'elevation-3' : animalType === 'cow'}]"
                                     height="50%"
                                     width="">Automático
                                </div>
                            </v-col>
                            <!-- fin de selector Automatico -->

                            <!-- inicio de selector Manual -->
                            <v-col cols="" class="ml-1">
                                <div class="mr-0 d-flex align-center justify-center full-height form-button-disabled px-0 std-border-radius std-text-sm-open"
                                     :class="[{'form-animal-active' : animalType === 'cow'}, {'elevation-3' : animalType === 'cow'}]"
                                     height="40px"
                                     width="50%">Manual
                                </div>
                            </v-col>
                            <!-- fin de selector Manual -->
                        </v-row>
                        <!-- fin de selector de Seleccion de Vacas-->
                        
                        <!--inicio de Filtro a Aplicar -->
                        <div class="col-12 std-text-sm std-text-blue-2 pa-0 mt-1">Filtro a aplicar a la selección</div>
                        <v-autocomplete
                                class="mb-2"
                                hide-details
                                dense
                                flat
                                placeholder="Edad (años)"
                                outlined
                                required
                        ></v-autocomplete>
                        <v-row no-gutters justify="space-between">
                                <v-checkbox label=3 hide-details class="smart-title-2 ma-0 pa-0"></v-checkbox>
                                <v-checkbox label=4 hide-details class="smart-title-2 ma-0 pa-0"></v-checkbox>
                                <v-checkbox label=5 hide-details class="smart-title-2 ma-0 pa-0"></v-checkbox>
                                <v-checkbox label=6 hide-details class="smart-title-2 ma-0 pa-0"></v-checkbox>
                                <v-checkbox label=más hide-details class="smart-title-2 ma-0 pa-0"></v-checkbox>
                        </v-row>
                        <!--Fin de Filtro a Aplicar -->
                    </v-col>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <!-- Fin de Seleccion de Vacas-->

        <!-- inicio de Seleccion de Indicador-->
        <v-expansion-panels multiple accordion class="my-6">
            <v-expansion-panel>
                <v-expansion-panel-header class="expansion-panel-background-color">
                    <b class="smart-title-2 home-title-container-mobile">Selección de indicador</b>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="expansion-panel-background-color">
                    <v-col cols="12" class="d-flex flex-wrap pa-0">
                        <!-- tarjeta de Vacas Preñadas -->
                       <v-row no-gutters style="d-flex" class="pa-0 my-2">
                           <v-col cols="11">
                                <v-row class="std-md-card-red d-flex block std-border-radius std-container-shadow-dense"
                                       no-gutters>
                                    <v-col class="col-4 d-flex align-center justify-center full-height">
                                        <i class="std-icon resume-cow-heat-icon"></i>
                                    </v-col>
                                    <v-col class="col-6 d-flex align-center justify-start std-text-white-1 font-weight-bold">Vacas<br>preñadas</v-col>
                                    <v-col class="col-2 d-flex align-center justify-center">
                                        <v-radio-group class="align-center justify-center pa-0 ma-0"
                                                       hide-details>
                                            <v-radio class="align-center justify-center pa-0 ma-0" color="white"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                           </v-col>
                           <v-col cols="1"
                                  class="d-flex align-center justify-end">
                                <i class="std-icon kpi-event-icon align-center justify-center"></i>
                           </v-col>
                       </v-row>
                       <!-- fin de tarjeta de Vacas Preñadas -->

                        <!-- tarjeta de Vacas en Celo -->
                        <v-row no-gutters style="d-flex" class="pa-0 my-2">
                            <v-col cols="11">
                                 <v-row class="std-md-card-blue d-flex block std-border-radius std-container-shadow-dense"
                                        no-gutters>
                                     <v-col class="col-4 d-flex align-center justify-center full-height">
                                         <i class="std-icon resume-cow-pregnant-icon"></i>
                                     </v-col>
                                     <v-col class="col-6 d-flex align-center justify-start std-text-white-1 font-weight-bold">Vacas en<br>celo</v-col>
                                     <v-col class="col-2 d-flex align-center justify-center">
                                         <v-radio-group class="align-center justify-center pa-0 ma-0"
                                                        hide-details>
                                             <v-radio class="align-center justify-center pa-0 ma-0"></v-radio>
                                         </v-radio-group>
                                     </v-col>
                                 </v-row>
                            </v-col>
                            <v-col cols="1"
                                   class="d-flex align-center justify-end">
                                 <i class="std-icon kpi-event-icon align-center justify-center"></i>
                            </v-col>
                        </v-row>
                        <!-- fin de tarjeta de Vacas en Celo -->

                        <!-- tarjeta de Vacas en Enfermas -->
                        <v-row no-gutters style="d-flex" class="pa-0 my-2">
                            <v-col cols="11">
                                 <v-row class="std-md-card-green d-flex block std-border-radius std-container-shadow-dense"
                                        no-gutters>
                                     <v-col class="col-4 d-flex align-center justify-center full-height">
                                         <i class="std-icon resume-cow-sick-icon"></i>
                                     </v-col>
                                     <v-col class="col-6 d-flex align-center justify-start std-text-white-1 font-weight-bold">Vacas<br>enfermas</v-col>
                                     <v-col class="col-2 d-flex align-center justify-center">
                                         <v-radio-group class="align-center justify-center pa-0 ma-0"
                                                        hide-details>
                                             <v-radio class="align-center justify-center pa-0 ma-0"></v-radio>
                                         </v-radio-group>
                                     </v-col>
                                 </v-row>
                            </v-col>
                            <v-col cols="1"
                                   class="d-flex align-center justify-end">
                                 <i class="std-icon kpi-event-icon align-center justify-center"></i>
                            </v-col>
                        </v-row>
                        <!-- fin de Vacas en Enfermas -->

                        <!-- tarjeta de DIM -->
                        <v-row no-gutters style="d-flex" class="pa-0 my-2">
                            <v-col cols="11">
                                 <v-row class="std-md-card-blue-dark d-flex block std-border-radius std-container-shadow-dense"
                                        no-gutters>
                                     <v-col class="col-4 d-flex align-center justify-center full-height">
                                         <i class="std-icon resume-cow-dim-icon"></i>
                                     </v-col>
                                     <v-col class="col-6 d-flex align-center justify-start std-text-white-1 font-weight-bold">Días en<br>leche</v-col>
                                     <v-col class="col-2 d-flex align-center justify-center">
                                         <v-radio-group class="align-center justify-center pa-0 ma-0"
                                                        hide-details>
                                             <v-radio class="align-center justify-center pa-0 ma-0"></v-radio>
                                         </v-radio-group>
                                     </v-col>
                                 </v-row>
                            </v-col>
                            <v-col cols="1"
                                   class="d-flex align-center justify-end">
                                 <i class="std-icon kpi-event-icon align-center justify-center"></i>
                            </v-col>
                        </v-row>
                        <!-- fin de tarjeta de DIM -->
                    </v-col>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <!-- fin de Seleccion de Indicador-->

        <!-- inicio de boton Registrar Potrero -->
        <v-row no-gutters justify="center">
            <v-col cols="8" class="">
                <v-btn block class="std-btn std-blue-btn"
                       height="40px">Agregar Potrero</v-btn>
            </v-col>
        </v-row>
        <!-- fin de boton Registrar Potrero -->

        <!-- inicio de controles inferiores -->
        <v-row cols="12" class="d-flex align-center justify-center"
               no-gutters
               style="position: absolute; bottom: 60px; width:90%">
            <v-col cols="4" class="d-flex align-center justify-start icon-container-arrows">
                <img src="../assets/Arrow_Left.svg" alt="#"/>
            </v-col>

            <v-col cols="4" class="d-flex align-center justify-center">
                <v-btn text class="my-2 d-flex std-text-grey">
                    Omitir paso
                </v-btn>
            </v-col>

            <v-col cols="4" class="d-flex align-center justify-end icon-container-arrows full-height">
                <img src="../assets/Arrow_Right.svg" alt="#"/>
            </v-col>
        </v-row>
        <!-- fin de controles inferiores -->
    </v-container>
</template>

<script>
    import ChangeRanch from '@/components/ChangeRanch.vue';
    export default {
      name: 'MobileComponents',
        data () {
          return {
          }
      },
      components: {
        ChangeRanch
      },
      computed: {
      },
      methods: {
      },
      mounted () {
      }
    };
</script>
    
<style lang="css">
    @import '../style/MobileCowStallConfiguration.css';
    @import '../style/BaseStyle.css';
</style>